// Foresters Financial

// Make sure any image references are for images located in "public/img"

export default {
  settings: {
    disableIframePostMessage: false,
  },

  defaults: {
    wageInflation: 4.0,
    priceInflation: 2.5,
    assetFee: 1.1,
    investmentRisk: 3, // Funeral doesn't allow High (4)
    investmentTerm: 25,
    extraContributionsRateOfIncrease: 0.25,
    requiredFuneralFund: 8000,

    // Investment values
    rbaCashRate: 3.6,
    investmentReturns: [
      null, // Ignore
      null, // Low (RBA cash rate)
      2,    // Moderate (2% + CPI)
      3,    // Moderate to high (3% + CPI)
      4,    // High (4% + CPI)
    ]
    
  },

  content: {
    general: {
      modellerName: "Bond Calculator",

      tabLabels: {
        welcomeTab: "Welcome",
        aboutTab: "About you",
        investmentsTab: "Investments",
        resultsTab: "Results",
        nextStepsTab: "Next steps",
        disclaimer: "Disclaimer",
        editableAssumptions: "Editable assumptions",
      },
    },

    welcome: {
      bannerHeading: `<h1>Bond Calculator</h1>`,
      content: `
      <h4>Grow your investments with confidence.</h4>
      `,
      acceptanceText: `
      I have read and accept the 
      <a href="javascript:;" class="internal-link disclaimer-link">disclaimer</a> and 
      <a href="javascript:;" class="internal-link assumptions-link">assumptions</a>.
      `,
      buttonLabel: "Get started",
    },

    about: {
      bannerHeading: `About you`,
      step1Heading: `About you`,
      step2Heading: `Your investment choice`,
      step3Heading: `Your contributions`,
      buttonLabel: "Continue",
      backButtonLabel: "Back",
    },

    investment: {
      bannerHeading: `Your investment choice`,
      buttonLabel: "Continue",
      backButtonLabel: "Back",
    },

    results: {
      bannerHeading: `Your results`,
      buttonLabel: "Continue",
      backButtonLabel: "Back",
    },

    whatsnext: {
      bannerHeading: `Next steps`,
      content: ``,
      backButtonLabel: "Back",
    },

    disclaimer: {
      bannerHeading: `Disclaimer`,
      content: `
      <div class="disclaimer-text">
        <h4>Purpose</h4>
        <p>These estimates are designed to assist you in understanding Investment and Funeral bond investments.</p>
        <p>The estimates are based on assumptions about future contributions, income drawings and investment earnings. There is inherent uncertainty in these estimates. They are illustrations and are not representations of guaranteed entitlements or benefits. They are not intended to be relied on for the purpose of making a financial decision, including a decision about a financial product. Before making any financial decisions consider your own financial circumstances, needs and objectives and consider getting personal financial advice from an AFS licensee.</p>
        <h4>Assumptions which comply with ASIC guidelines</h4>
        <p>The following assumptions comply with the default assumptions for financial calculators set by ASIC:</p>
        <ul>
          <li>The estimates of future balances and income amounts are in present values.</li>
          <li>Price inflation is assumed to be 2.5% pa and is used to discount future amounts to present values.</li>
        </ul>
        <h4>Administration fees</h4>
        <p>The following administration fee have been assumed:</p>
        <table>
          <tbody>
            <tr>
              <td>Asset fee (% pa)</td>
              <td>1.1%</td>
            </tr>
          </tbody>
        </table>
        <p>This fee applies to Investment Bond, Funeral Bond, and Managed fund calculations.</p>
        <h4>Investment returns</h4>
        <p>The following investment returns have been assumed:</p>
        <table>
          <tbody>
            <tr>
              <th>Investment option</th>
              <th>Investment return</th>
            </tr>
            <tr>
              <td>Moderate</td>
              <td>4.5%</td>
            </tr>
            <tr>
              <td>Moderate to High</td>
              <td>5.5%</td>
            </tr>
            <tr>
              <td>High</td>
              <td>6.5%</td>
            </tr>
          </tbody>
        </table>
        <h4>Investment bond</h4>
        <p>The calculations allow for 30% tax on investment income.</p>
        <p>It is assumed you will retain the bond for at least 10 years, and so no capital gains tax is levied.</p>
        <h4>Managed fund</h4>
        <p>It is assumed that the managed fund is held in your own name. Income tax is paid based on investment income at marginal rates, allowing for other income amounts you have entered.</p>
        <p>Capital gains tax is calculated at the time funds are withdrawn, either due to a regular income plan, or at the end of the investment term.</p>
        <p>Where you establish an income plan, when income is drawn from the managed fund it is assumed that an additional amount will be withdrawn to fund capital gains tax on realised gains. It is assumed that capital gains are drawn based on the proportion of total accrued assets arising from accrued capital gains.</p>
        <p>At the end of the investment term, capital gains tax is calculated based on the balance in the managed fund at the time.</p>
        <p>Capital gains tax is paid at marginal income tax rates, allowing for other income amounts. The calculations allow for the 50% capital gains tax discount.</p>
        <h4>Bank savings account</h4>
        <p>It is assumed that the bank savings account is held in your own name. Income tax is paid based on investment income at marginal rates, allowing for other income amounts you have entered.</p>
        <p>As these calculations assume funds are invested in a bank account, the total return would not include any capital gains component and capital gains tax is not relevant.</p>
      </div>`,
      backButtonLabel: "Back to calculator",
    },

    assumptions: {
      bannerHeading: `Assumptions`,
      backButtonLabel: "Back to calculator",
    },
  },

  params: {
    priceInflation: {
      min: 0,
      max: 10,
    },

    wageInflation: {
      min: 0,
      max: 10,
    },

    assetFee: {
      min: 0.9,
      max: 2,
    },

    customInvestmentReturn: {
      min: 0.1,
      max: 10, // was 6.5
    },

    startingDeposit: {
      investmentMin: 500,
      investmentMax: 100000000,
      funeralMin: 100,
      funeralMax: 1000000,
      educationMin: 0,
      educationMax: 0
    },

    extraContributions: {
      investmentMin: 60,
      investmentMax: 500000,
      funeralMin: 25,
      funeralMax: 10000,
      educationMin: 0,
      educationMax: 0
    },
  },

  // analytics: {
  //   gacode: "GTM-XXXXXXX",
  //   gaprod: "GTM-XXXXXXX",
  // },

  lastUpdated: "1 May 2023",
};
